import { render, staticRenderFns } from "./ArtistCard.vue?vue&type=template&id=574b6caa"
import script from "./ArtistCard.vue?vue&type=script&lang=js"
export * from "./ArtistCard.vue?vue&type=script&lang=js"
import style0 from "./ArtistCard.vue?vue&type=style&index=0&id=574b6caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports